// extracted by mini-css-extract-plugin
export var avatarContainer = "_go-0";
export var avatarTypingWave = "_go-i";
export var gray = "_go-f";
export var green = "_go-c";
export var icon = "_go-9";
export var image = "_go-1";
export var lg = "_go-6";
export var md = "_go-5";
export var presenceDot = "_go-b";
export var red = "_go-d";
export var sm = "_go-4";
export var status = "_go-a";
export var typingDot = "_go-h";
export var typingPill = "_go-g";
export var xl = "_go-7";
export var xs = "_go-3";
export var xxl = "_go-8";
export var xxs = "_go-2";
export var yellow = "_go-e";